// import { faFacebook, faGoogle } from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faLock,
  //faArrowLeft,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState ,useRef } from "react";
//import Logo from "../../../images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import SocialLogin from "../SocialLogin/SocialLogin";
//import logo1 from "../../../images/logo1.png";
import { useTranslation } from "react-i18next";
import { signUpApi, sendotp, legalDisclaimerApi, getCountries } from "../../../api/user";
import { toast } from "react-toastify";
import PageContainer from "../../../components/pages/PageContainer";
import { event } from "../../../utils/event";
import LegalPopupModal from "../../../components/Modals/legalDisclaimer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function RegisterIndex() {
  //const { t, i18n } = useTranslation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showPopup, setShowPopUp] = useState(false);
  const [checked, setChecked] = useState(false);
  // New states for date_of_birth and country_of_origin
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [maxDate, setMaxDate] = useState(new Date());
  const [displayDate, setDisplayDate] = useState("");
  const dateInputRef = useRef(null); // Ref to access the hidden date input
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);


  const [countryOfOrigin, setCountryOfOrigin] = useState("");
  const [countries, setCountries] = useState([]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleClose = () => {
    navigate("/auth/verification");
    localStorage.setItem("checkDisclaimer", false);
    return setShowPopUp(false);
  };

  const handleCheckboxChange1 = () => {
    setChecked(!checked);
  };

  useEffect(() => {
    event("sendDataToReactApp");

      const fetchCountries = async () => {
    try {
      const response = await getCountries();

      // Ensure the correct part of the response is used
      if (response.data && response.data.success) {
        setCountries(response.data.data); // Use `response.data.data` to set the countries
      } else {
        console.error("Failed to fetch countries:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  fetchCountries();

  }, []);

  // Calculate maxDate (restrict to 13 years ago)
  // const today = new Date();
  // today.setFullYear(today.getFullYear() - 13);
  // const maxDate = today.toISOString().split("T")[0]; // yyyy-mm-dd format

  // // Function to format date to MM-DD-YYYY for display
  // const formatDateForDisplay = (dateString) => {
  //   if (!dateString) return "";
  //   const date = new Date(dateString);
  //   return `${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}-${date.getFullYear()}`;
  // };

  // // Handle user input from date picker
  // const handleDateChange = (e) => {
  //   setDateOfBirth(e.target.value); // Store in yyyy-mm-dd format (for backend)
  //   setDisplayDate(formatDateForDisplay(e.target.value)); // Show in MM-DD-YYYY format
  // };

  useEffect(() => {
    // Restrict selection to users 13+ years old
    const today = new Date();
    today.setFullYear(today.getFullYear() - 13);
    setMaxDate(today);
  }, []);

    const handleDateChange = (date) => {
    if (date) {
      const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12); // Forces midday to avoid timezone shifts
      setDateOfBirth(localDate);
    } else {
      setDateOfBirth(null);
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    // Basic email validation
    if (!email || email === "") {
      setError({ email: ["Please enter your email"] });
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError({ email: ["Invalid email address"] });
      return;
    }
    if (!password || password === "") {
      setError({ password: ["Please enter your password"] });
      return;
    }

    // Password validation
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*[a-z]).{8,}$/;
    if (!passwordRegex.test(password)) {
      setError({
        password: [
          'Password must be at least 8 characters and include one capital letter and one special character (!@#$%^&*(),.?":{}|<>)',
        ],
      });
      return;
    }


    // Check if date_of_birth and country_of_origin are selected
    // if (!dateOfBirth) {
    //   setError({ dateOfBirth: ["Please select your date of birth"] });
    //   return;
    // }

    // if (!countryOfOrigin) {
    //   setError({ countryOfOrigin: ["Please select your country of origin"] });
    //   return;
    // }

     if (!isChecked) {
      setError({
        isChecked: ["Please accept the Privacy Policy to sign up!"],
      });
      // Display an error message or take appropriate action

      return;
    }

    setError(null);
    setLoading(true);

    const body = {
      email: email,
      password: password,
      date_of_birth: dateOfBirth,
      country_of_origin: countryOfOrigin,
    };

    try {
      const response = await signUpApi(body);
      if (response.data.status === 200) {
        // console.log(response, "abc");
        setLoading(false);
        setShowPopUp(true);
        localStorage.setItem("checkDisclaimer", true);
        const accessToken = response.data.data.access_token;
        localStorage.setItem("user_id", response.data.data.id);
        localStorage.setItem("accessToken", JSON.stringify(accessToken));

        const ema = { email: response.data.data.email, otp_purpose: 2 };
        const respo = await sendotp(ema);

        localStorage.setItem("email_token", respo.data.data.email_token);
        localStorage.setItem("email", response.data.data.email);
      } else if (response.data.status === 400) {
        // console.log(response, "abc");
        setLoading(false);
        // navigate("/auth/verification")
        toast.error(response.data.message);
        // Redirect or perform other actions upon successful login
      }
    } catch (error) {
      console.log("Error:", error);
      setLoading(false);
      toast.error(error?.response?.data?.message);
      // Handle login error (e.g., show an error message)
    }
  };

  const handleLegalPopup = async () => {
    if (!checked) {
      toast.error("Please accept our legal policies.");
      return;
    }
    //const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    try {
      const res = await legalDisclaimerApi(checked);
      if (res?.data?.status === 200) {
        // TPSS
        // setShowPopUp(false);
        // if (userInfo?.user_name) {
        //   navigate("/profile");
        // } else {
        //   navigate("/edit-profile");
        // }
        // localStorage.setItem("checkDisclaimer", false);
        handleClose();
      }
    } catch (err) {}
  };

  return (
    <>
      <PageContainer>
<div className="flex min-h-screen">
  <div className="flex justify-center w-full flex-col md:flex-row">

    {/* Left Side — Branding / Logo Section */}
    <div className="md:bg-primaryColor md:min-h-screen flex flex-wrap md:w-1/2">
      {!isMobileView && (
        <div className="items-center text-center flex flex-col relative justify-center mx-auto mt-2">
          <img
            src={"/qushi_logo.png"}
            alt="Logo Login"
            className="md:w-48 w-48 mx-auto"
          />
        </div>
      )}
    </div>

    {/* Right Side — Sign Up Form */}
            <div className="flex flex-col md:w-1/2 items-center justify-center">
              <div className="w-full  loginWrapper flex flex-col lg:w-3/5 max-w-md lg:px-10 md:px-5 px-5 pt-2">
                {/* Login Header Text */}
                <div className="items-center text-center flex flex-col justify-center mx-auto relative">
                  <img
                    src={"/qushi_logo.png"}
                    alt="Logo Login"
                    className="md:w-32 mt-4 w-32 mx-auto"
                  />
                </div>
                <div className="mt-1 hidden md:block font-medium self-center text-xl sm:text-3xl text-gray-800">
                  {t("sign_up")}
                </div>

                {/* Sparator */}
                <div className="hidden md:block relative mt-4 h-px bg-gray-300">
                  <div className="absolute left-0 top-0 flex justify-center w-full mt-2"></div>
                </div>

                <div className="md:hidden block my-4">
                  <h1 className="text-2xl font-semibold text-center">
                    {t("sign_up")}
                  </h1>
                </div>

                {/* Login Form */}
                <div className="md:mt-6 mt-4">
                  <form onSubmit={handleSubmit}>
                    {/* Username */}
                    <div className="flex flex-col mb-3">
                      <div className="flex flex-col">
                        <label className="text-xs mb-2 text-gray-400">
                          {t("Email Address")}
                        </label>
                        <div className="relative">
                          <div className="inline-flex items-center justify-center absolute left-0 top-0 h-9 w-10 text-gray-400 mt-1 sm:mt-0">
                            <FontAwesomeIcon icon={faEnvelope} />
                          </div>

                          <input
                            id="email"
                            type="text"
                            name="email"
                            onChange={(e) => setEmail(e.target.value)}
                            className="text-sm placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full md:py-2 py-3 focus:outline-none focus:border-emerald-400"
                            placeholder=""
                          />
                        </div>
                      </div>
                      {error?.email && (
                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                          {error.email[0]}
                        </span>
                      )}
                    </div>

                    {/* Password */}
                    <div className="flex flex-col mb-4">
                      <div className="flex flex-col">
                        <label className="text-xs mb-2 text-gray-400">
                          {t("Password")}
                        </label>
                        <div className="relative">
                          <div className="inline-flex items-center justify-center absolute left-0 top-0 h-9 w-10 text-gray-400 mt-1 sm:mt-0">
                            <FontAwesomeIcon icon={faLock} />
                          </div>

                          <input
                            id="password"
                            type={showPassword ? "text" : "password"}
                            name="password"
                            onChange={(e) => setPassword(e.target.value)}
                            className="text-sm placeholder-gray-500 pl-10 pr-4 rounded-lg border border-gray-400 w-full md:py-2 py-3 focus:outline-none focus:border-emerald-400"
                            placeholder=""
                          />
                          <div
                            className="inline-flex items-center justify-center absolute right-0 top-0 h-9 w-10 text-gray-400 cursor-pointer mt-1 sm:mt-0"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? (
                              <FontAwesomeIcon icon={faEyeSlash} />
                            ) : (
                              <FontAwesomeIcon icon={faEye} />
                            )}
                          </div>
                        </div>
                      </div>
                      {error?.password && (
                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                          {error.password[0]}
                        </span>
                      )}
                    </div>


                      {/* Date of Birth */}
    <div className="flex flex-col mb-4">
      <label className="text-xs mb-2 text-gray-400">{t("Share your age with us —it’s private and helps us understand our users better. Thanks for helping us improve!")}</label>

      {/* React DatePicker (Replaces input[type="date"]) */}
      <DatePicker
        selected={dateOfBirth}
        onChange={handleDateChange}
        dateFormat="MM-dd-yyyy" // Ensures MM-DD-YYYY format
        placeholderText="MM-DD-YYYY"
        maxDate={maxDate} // Prevents selecting future dates
        showYearDropdown // Enables year selection dropdown
        scrollableYearDropdown // Allows scrolling through years
        yearDropdownItemNumber={100} // Shows 100 years in dropdown
        showMonthDropdown // Enables month selection dropdown
        className="border px-3 py-2 rounded-lg !w-full"
      />

    </div>


                    {/* Country of Origin */}
                    <div className="flex flex-col mb-6">
                      <div className="flex flex-col">
                        <label className="text-xs mb-2 text-gray-400">
                          {t("Country of Origin")}
                        </label>
                        {/* <select
                          name="country_of_origin"
                          value={countryOfOrigin}
                          onChange={(e) => setCountryOfOrigin(e.target.value)}
                          className="text-sm placeholder-gray-500 pl-4 pr-4 rounded-lg border border-gray-400 w-full md:py-2 py-3 focus:outline-none focus:border-emerald-400"
                        >
                          <option value="" disabled>
                            {t("Select Country of Origin")}
                          </option>
                          {countries.map((country, index) => (
                            <option key={index} value={country.id}>
                              {country.name}
                            </option>
                          ))}
                        </select> */}
                        <select
  name="country_of_origin"
  value={countryOfOrigin}
  onChange={(e) => setCountryOfOrigin(e.target.value)}
  className="text-sm placeholder-gray-500 pl-4 pr-4 rounded-lg border border-gray-400 w-full md:py-2 py-3 focus:outline-none focus:border-emerald-400"
>
  <option value="" disabled>
    {t("Select Country of Origin")}
  </option>

  {/* Sort the countries before rendering */}
  {[
    ...countries.filter((c) => c.id === countryOfOrigin), // Keep selected country at top
    ...countries.filter((c) => c.name === "United States" && c.id !== countryOfOrigin), // Move "India" to the top if it's not selected
    ...countries.filter((c) => c.name !== "United States" && c.id !== countryOfOrigin), // Keep other countries
  ].map((country, index) => (
    <option key={index} value={country.id}>
      {country.name}
    </option>
  ))}
</select>

                      </div>
                      {error?.countryOfOrigin && (
                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                          {error.countryOfOrigin[0]}
                        </span>
                      )}
                    </div>


                    {/* Forgot Password Link */}
                    {/* <div className="flex items-center mb-6 -mt-2 md:-mt-4">
                    <div className="flex ml-auto">
                      <Link
                        to=""
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                        className="inline-flex font-semibold text-xs sm:text-sm text-gray-400 hover:text-primaryColor underline"
                      >
                        {t("forgot_your_password")}?
                      </Link>
                    </div>
                  </div> */}
                    <div className="flex flex-row justify-start items-center pl-1">
                      <div className="flex flex-row justify-start items-center">
                        <div>
                          <input
                            type="checkbox"
                            className="mt-1 cursor-pointer"
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                          />
                        </div>{" "}
                        <div className="flex">
                          <p className="text-xs whitespace-nowrap ml-2 items-center text-gray-400 justify-center h-full">
                            {t("By continuing you accept our")}{" "}
                            <a
                              href="https://qushi.io/privacy_policy.php"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <strong>
                                <u>{t("Privacy Policy")}</u>
                              </strong>
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>


                    <div className="flex flex-row justify-start items-center pl-1 mb-5">
                      <div className="flex flex-row justify-start items-center">
                        <div>
                                          {error?.isChecked && (
                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs  ml-1">
                          {error.isChecked[0]}
                        </span>
                      )}

                      </div>
                    </div>
                    </div>

                    {/* Button Login */}
                    <div className="flex w-full">
                      <button
                        disabled={loading}
                        type="submit"
                        className="flex items-center justify-center focus:outline-none text-white text-sm bg-primaryColor rounded-xl md:rounded-xl md:py-3 py-3 w-full"
                      >
                        <span className="mr-2 md:uppercase">
                          {loading ? "Processing...." : "Create Account"}
                        </span>
                      </button>
                    </div>
                    <div className=" flex flex-col">
                      {/* Sparator */}
                      <div className="md:block relative my-4 h-px bg-gray-300">
                        <div className="absolute left-0 top-0 flex justify-center w-full mt-2"></div>
                      </div>

                      <div className="flex flex-row justify-center items-center">
                        <p className="text-xs whitespace-nowrap ml-2 items-center mb-1 text-gray-400 justify-center h-ful">
                          {t("already_have_account")}?
                        </p>
                        <div className="flex">
                          <Link
                            to="/auth/login"
                            // onClick={(e) => {
                            //   e.preventDefault();
                            // }}
                            className="inline-flex mb-1 font-semibold text-xs sm:text-sm ml-1 text-gray-400 hover:text-primaryColor underline"
                          >
                            {t("sign_in")}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                {/* Social Button */}
                <SocialLogin />
                {/* End Social Button */}
              </div>
            </div>

  </div>
</div>
      </PageContainer>
      <LegalPopupModal
        isOpen={showPopup}
        handleLegalPopup={handleLegalPopup}
        checked={checked}
        handleClose={handleClose}
        handleCheckboxChange1={handleCheckboxChange1}
      />
    </>
  );
}

export default RegisterIndex;
